import {useMutation, useQueryClient} from '@tanstack/react-query';

import {updateGeoFilter, UpdateGeoFilterParams} from '../api';
import {QUERY__GEO_FILTER_OPTIONS} from '../queryKeys';

export const useUpdateGeoFilter = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateGeoFilterParams) => updateGeoFilter(params),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__GEO_FILTER_OPTIONS],
      });
      void queryClient.invalidateQueries({
        queryKey: [QUERY__GEO_FILTER_OPTIONS, variables.slug],
      });
    },
  });
};
